import FTAnalytic from "@/analyze/FTAnalytic";
import { NAV_POSITION, PROJECT_TYPE } from "@/constants";
import { useUserStore } from "@/stores";
import useEffectStore from "@/stores/effectStore";

const getCommonAnalyseObj = async () => {
  await new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, 100);
  });
  const { currentEffect, task } = useEffectStore.getState();
  const id = currentEffect?.id ?? "";
  const sizeId = currentEffect?.id;
  const sizeName =
    currentEffect?.type === "custom" ? "custom" : currentEffect?.title;
  const { isLogin } = useUserStore.getState().getters;
  return {
    id,
    sizeId,
    sizeName,
    project_type: PROJECT_TYPE,
    task_id: task?.taskId ?? "",
    isLogin,
  };
};
export default class Analyse {
  private static instance: Analyse;

  private constructor() {}
  projectType = PROJECT_TYPE;

  public static getInstance(): Analyse {
    if (!Analyse.instance) {
      Analyse.instance = new Analyse();
    }
    return Analyse.instance;
  }
  async enterPage() {
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$enter$figure_project_page",
      label: {
        location: NAV_POSITION,
        project_type: PROJECT_TYPE,
      },
    });
  }

  async generateTaskCallBack(isSuccess: boolean, failReason: string) {
    const { project_type, sizeId, sizeName, task_id } =
      await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$callback$figure_task",
      label: {
        is_success: isSuccess,
        fail_reason: failReason,
        project_type,
        size_id: sizeId,
        size_name: sizeName,
        taskid: task_id,
      },
    });
  }
  /**
   * 打开模板
   */
  async openTarget() {
    // const {
    //   type,
    //   project_type,
    //   face_swap_count,
    //   resourceId,
    //   sizeId,
    //   sizeName,
    // } = await getCommonAnalyseObj();
    // FTAnalytic.addAnalytic({
    //   type: "ev",
    //   action: "fotor_web$click_up$swap_project_page_open",
    //   label: {
    //     type,
    //     project_type,
    //     position: "target",
    //     face_swap_count,
    //     resource_id: resourceId,
    //     size_id: sizeId,
    //     size_name: sizeName,
    //   },
    // });
  }
  async openTargetCallback(isSuccess: boolean, failReason: string) {
    // const {
    //   type,
    //   project_type,
    //   resourceId,
    //   sizeId,
    //   sizeName,
    //   face_swap_count,
    // } = await getCommonAnalyseObj();
    // FTAnalytic.addAnalytic({
    //   type: "ev",
    //   action: "fotor_web$callback$swap_project_page_open",
    //   label: {
    //     type,
    //     project_type,
    //     position: "target",
    //     face_swap_count,
    //     is_success: isSuccess,
    //     fail_reason: failReason,
    //     resource_id: resourceId,
    //     size_id: sizeId,
    //     size_name: sizeName,
    //   },
    // });
  }

  async openFaceSwap() {
    // const { type, project_type, face_swap_count } = await getCommonAnalyseObj();
    // FTAnalytic.addAnalytic({
    //   type: "ev",
    //   action: "fotor_web$click_up$swap_project_page_open",
    //   label: {
    //     type,
    //     project_type,
    //     position: "face",
    //     face_swap_count,
    //   },
    // });
  }

  async openFaceSwapCallback(isSuccess: boolean, failReason: string) {
    // const { type, project_type, face_swap_count } = await getCommonAnalyseObj();
    // FTAnalytic.addAnalytic({
    //   type: "ev",
    //   action: "fotor_web$callback$swap_project_page_open",
    //   label: {
    //     type,
    //     project_type,
    //     position: "face",
    //     is_success: isSuccess,
    //     fail_reason: failReason,
    //     face_swap_count,
    //   },
    // });
  }

  async clickUpImage(button_position: string) {
    const { project_type } = await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$click_up$figure_upload_img",
      label: {
        position: "face",
        project_type,
        button_position,
      },
    });
  }

  async clickUpImageCallback(
    isSuccess: boolean,
    failReason: string,
    button_position: string
  ) {
    const { project_type, sizeId, sizeName, isLogin } =
      await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$callback$figure_upload_img",
      label: {
        project_type,
        is_success: isSuccess,
        fail_reason: failReason,
        button_position: button_position,
      },
    });
  }

  async clickUpGenerate(button_status: "start" | "no_credits" | "no_login") {
    const { project_type, sizeId, sizeName, isLogin } =
      await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$click_up$figure_style",
      label: {
        project_type,
        button_position: "start",
        button_status,
        size_id: sizeId,
        size_name: sizeName,
      },
    });
  }
  async startTaskGererate() {
    const { project_type, sizeId, sizeName, task_id } =
      await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$start$figure_task",
      label: {
        is_success: true,
        project_type,
        size_id: sizeId,
        size_name: sizeName,
        button_status: "start",
        position: "face",
        taskid: task_id,
      },
    });
  }
  async startTaskGererateError(is_success: boolean, fail_reason: string) {
    const { project_type, sizeId, sizeName, task_id } =
      await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$callback$figure_task",
      label: {
        is_success: is_success,
        fail_reason: fail_reason,
        position: "face",
        project_type,
        size_id: sizeId,
        size_name: sizeName,
        taskid: task_id,
      },
    });
  }

  async startGenerate() {
    const { project_type, sizeId, sizeName, task_id } =
      await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$start$figure_generate",
      label: {
        project_type,
        size_id: sizeId,
        size_name: sizeName,
        taskid: task_id,
      },
    });
  }

  async startGenerateCallback(is_success: boolean, fail_reason: string) {
    const { project_type, sizeId, sizeName, task_id } =
      await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$callback$figure_generate",
      label: {
        project_type,
        size_id: sizeId,
        size_name: sizeName,
        taskid: task_id,
        is_success,
        fail_reason,
      },
    });
  }

  async download(button_position: string) {
    const { project_type, sizeId, sizeName, task_id } =
      await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$click_up$figure_download",
      label: {
        project_type,
        size_id: sizeId,
        size_name: sizeName,
        button_position: button_position,
        taskid: task_id,
      },
    });
  }

  async downloadResult(button_position: string) {
    const { project_type, sizeId, sizeName, task_id } =
      await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$callback$figure_download",
      label: {
        project_type,
        size_id: sizeId,
        size_name: sizeName,
        button_position: button_position,
        taskid: task_id,
        is_success: true,
        fail_reason: "",
      },
    });
  }

  async featureClick(button_position: string) {
    const { project_type } = await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$click_up$figure_features",
      label: {
        project_type,
        button_position,
      },
    });
  }
}
